@if (label) {
  <span class="sui-toggle__label" [innerHTML]="label"></span>
}
<div
  ngpToggleGroup
  ngpToggleGroupType="single"
  [id]="effectiveId"
  [ngpToggleGroupAllowDeselection]="false"
  [ngpToggleGroupValue]="groupValue"
  [ngpToggleGroupDisabled]="isDisabled()"
  (ngpToggleGroupValueChange)="onValueChange($event)"
  [attr.aria-label]="label || null"
  [attr.aria-invalid]="errorState ? 'true' : null"
  [class.sui-toggle--invalid]="errorState"
  [attr.data-state]="selectedState"
  [attr.data-position]="selectedPosition"
  class="track"
>
  @for (option of options; track option) {
    <button
      type="button"
      class="segment"
      ngpToggleGroupItem
      [ngpToggleGroupItemValue]="option.key"
      [ngpToggleGroupItemDisabled]="isDisabled()"
      [attr.aria-label]="option.label"
    ></button>
  }
  <span class="thumb" aria-hidden="true"></span>
</div>
